import React from 'react';
import { IntlProvider } from 'react-intl';
import translations from '../i18n/translations/index.js';
import { DEFAULT_LOCALE, LOCALE_CODES } from '../constants/locale.js';

const LocaleContextProvider = _ref => {
  let {
    children,
    locale = DEFAULT_LOCALE
  } = _ref;
  const selectedLocale = LOCALE_CODES.includes(locale) ? locale : DEFAULT_LOCALE;
  return /*#__PURE__*/React.createElement(IntlProvider, {
    defaultLocale: DEFAULT_LOCALE,
    locale: selectedLocale,
    messages: translations[selectedLocale],
    wrapRichTextChunksInFragment: true //https://github.com/formatjs/formatjs/issues/1549
  }, children);
};
var LocaleContextProvider$1 = LocaleContextProvider;

export { LocaleContextProvider$1 as default };
